"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildSanitizer = void 0;

var _sanitize = _interopRequireDefault(require("sanitize"));

// For specific documentation on the Sanitize.js library, config, or transformers, see: https://github.com/gbirke/Sanitize.js
var buildSanitizer = function buildSanitizer(config) {
  return new _sanitize.default(config);
};

exports.buildSanitizer = buildSanitizer;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/sanitize-text/static-1.1206/js/sanitizers/buildSanitizer.js
// module id = 811
// module chunks = 209 210 211 212